import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/404.png'


const _hoisted_1 = {
  key: 0,
  class: "timeline-container"
}
const _hoisted_2 = { class: "lineleft" }
const _hoisted_3 = { class: "entry-list" }
const _hoisted_4 = { class: "infor-list" }
const _hoisted_5 = { class: "flow-header" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "user" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "nickname" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "content post-content" }
const _hoisted_14 = { class: "sidebar-container" }
const _hoisted_15 = {
  key: 1,
  class: "empty-list"
}

import { onMounted, reactive, toRefs, markRaw, ref } from "vue";
import MainHeader from "@/components/main-header.vue";
import UserItem from "@/components/User-Item.vue";

import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import axiosInstance from "@/utils/axiosInstance";

import { Viewer } from "@bytemd/vue-next";

import gfm from "@bytemd/plugin-gfm";
import "bytemd/dist/index.css";

// 突出显示代码块
import highlight from "@bytemd/plugin-highlight";
import "highlight.js/styles/default.css";

// 对齐方式
import alignPlugin from "bytemd-plugin-align";
// 主题
import theme from "bytemd-plugin-theme";
// 解析前言 格式化
import frontmatter from "@bytemd/plugin-frontmatter";
// 表情
import gemoji from "@bytemd/plugin-gemoji";

// 代码高亮
import highLightPlugin from "bytemd-plugin-highlight";
// 图片的缩放
import imagePlugin from "bytemd-plugin-image";
// 代码复制
import copyCode from "bytemd-plugin-copy-code";
import "bytemd-plugin-copy-code/dist/style/index.css";

// 缩放图片 点击图片放大,再点击缩小
import mediumZoom from "@bytemd/plugin-medium-zoom";
// 图表
import mermaid from "@bytemd/plugin-mermaid";
import mermaidLocale from "@bytemd/plugin-mermaid/locales/zh_Hans.json";
// 数学公式插件
import math from "@bytemd/plugin-math";
import mathLocale from "@bytemd/plugin-math/locales/zh_Hans.json";
import "katex/dist/katex.css";

import zhHans from "bytemd/locales/zh_Hans.json";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleDetail',
  setup(__props) {

const SSRData = ref({
  title: "",
  description: "",
  keywords: "宁波技术社区,默认代码,程序员中文技术社区,前端开发社区,前端技术交流,前端框架教程",
});

// 插件
const pluginsList = [
  gfm(),
  math({
    locale: mathLocale,
  }),
  alignPlugin(),
  highLightPlugin(),
  imagePlugin(),
  copyCode({
    copySuccess: (text) => {
      console.log(text);
      ElMessage.success("代码复制成功");
    },
    copyError: (err) => {
      console.log(err);
    },
  }),
  mediumZoom(),
  mermaid({
    locale: mermaidLocale,
  }),
  highlight(),
  theme(),
  frontmatter(),
  gemoji(),
];

const router = useRouter();

// 编辑器数据初始化
const state = reactive({
  value: "",
  plugins: markRaw(pluginsList),
  zh: zhHans,
  isempty: ref(true),
});

const { value, plugins, zh, markDownRef } = toRefs(state);

//文章信息
const DetailInfo = reactive({
  article_id: "",
  title: "",
  info_content: "",
  category_id: "",
  category_name: "",
  brief_content: "",
  link_url: "",
  cover_image: "",
  comment_count: "",
  view_count: "",
  digg_count: "",
  favorited_count: "",
  is_markdown: "",
  is_hot: "",
  uuid: "",
  author: "",
  created_at: "",
  avatar_url: ""
});

onMounted(async () => {
  //获取文章ID 参数
  const postID = router.currentRoute.value.params.postID as string;
  fetchArticleInfoData(postID);
});

// 获取文章数据
const fetchArticleInfoData = async (postID: string) => {
  try {
    await axiosInstance
      .get("/api/HomeArticle/detail", {
        params: { article_id: postID },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          const articleData = result.data;
          DetailInfo.article_id = articleData.article_id;
          DetailInfo.title = articleData.title;
          DetailInfo.info_content = articleData.info_content;
          DetailInfo.category_id = articleData.category_id;
          DetailInfo.category_name = articleData.category_name;
          DetailInfo.brief_content = articleData.brief_content;
          DetailInfo.link_url = articleData.link_url;
          DetailInfo.cover_image = articleData.cover_image;
          DetailInfo.comment_count = articleData.comment_count;
          DetailInfo.view_count = articleData.view_count;
          DetailInfo.digg_count = articleData.digg_count;
          DetailInfo.favorited_count = articleData.favorited_count;
          DetailInfo.is_markdown = articleData.is_markdown;
          DetailInfo.is_hot = articleData.is_hot;
          DetailInfo.uuid = articleData.uuid;
          DetailInfo.author = articleData.author;
          DetailInfo.avatar_url = articleData.avatar_url;
          DetailInfo.created_at = articleData.created_at;
          state.value = articleData.info_content;
          //SEO 内容
          SSRData.value.title = articleData.title+' - '+WebSite_Name;
          SSRData.value.description = articleData.brief_content;
        } else {
          state.isempty = false;
          //SEO 内容
          SSRData.value.title = '找不到页面';
          SSRData.value.description = '';
          SSRData.value.keywords = '';
        }
        setSSRHead();
      });
  } catch (error) {
    ElMessage.error("获取文章数据失败");
  }
};

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    (state.isempty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      href: `/user/${DetailInfo.uuid}`,
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: DetailInfo.avatar_url,
                          class: "avatar"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(DetailInfo.author), 1),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(DetailInfo.created_at) + " 创建", 1)
                        ])
                      ])
                    ], 8, _hoisted_6)
                  ]),
                  _createElementVNode("h1", _hoisted_12, _toDisplayString(DetailInfo.title), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(Viewer), {
                      ref_key: "markDownRef",
                      ref: markDownRef,
                      locale: _unref(zh),
                      value: _unref(value),
                      plugins: _unref(plugins)
                    }, null, 8, ["locale", "value", "plugins"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(UserItem, {
                "user-id": DetailInfo.uuid
              }, null, 8, ["user-id"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!state.isempty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "null-infor-list" }, [
            _createElementVNode("div", { class: "content-flag" }, [
              _createElementVNode("div", { class: "common-empty" }, [
                _createElementVNode("img", { src: _imports_0 })
              ])
            ])
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})